class TimelineComponent extends HTMLElement {
  constructor() {
    super();
    this.resizeTimeout = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.updateTimelineLine();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => this.updateTimelineLine(), 100);
  }

  updateTimelineLine() {
    const line = this.querySelector('.timeline__line');
    const steps = this.querySelectorAll('.timeline__step');
    const wrapper = this.querySelector('.timeline__wrapper');

    if (!line || steps.length === 0 || !wrapper) return;

    const firstDot = steps[0].querySelector('.timeline__dot');
    const lastDot = steps[steps.length - 1].querySelector('.timeline__dot');

    if (!firstDot || !lastDot) return;

    // Use the .timeline__wrapper as the reference since it has position: relative
    // and is the positioning context for the absolute line
    const wrapperRect = wrapper.getBoundingClientRect();

    if (window.innerWidth >= 768) {
      const firstDotRect = firstDot.getBoundingClientRect();
      const lastDotRect = lastDot.getBoundingClientRect();

      const startPos = firstDotRect.left - wrapperRect.left + firstDotRect.width / 2;
      const endPos = lastDotRect.left - wrapperRect.left + lastDotRect.width / 2;
      const lineWidth = endPos - startPos;

      line.style.left = startPos + 'px';
      line.style.width = lineWidth + 'px';
      line.style.right = 'auto';
      line.style.top = '';
      line.style.height = '';
      line.style.bottom = '';
    } else {
      const firstDotRect = firstDot.getBoundingClientRect();
      const lastDotRect = lastDot.getBoundingClientRect();

      const startPos = firstDotRect.top - wrapperRect.top + firstDotRect.height / 2;
      const endPos = lastDotRect.top - wrapperRect.top + lastDotRect.height / 2;
      const lineHeight = endPos - startPos;

      line.style.top = startPos + 'px';
      line.style.height = lineHeight + 'px';
      line.style.bottom = 'auto';
      line.style.left = '';
      line.style.width = '';
      line.style.right = '';
    }
  }
}

customElements.define('timeline-component', TimelineComponent);
